import { render, staticRenderFns } from "./Worktab.vue?vue&type=template&id=2fa50518&"
import script from "./Worktab.vue?vue&type=script&lang=js&"
export * from "./Worktab.vue?vue&type=script&lang=js&"
import style0 from "./Worktab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports